<template>
  <div class="layout">
    <div class="header" :class="$route.name === 'home' ? 'home-header header' : 'header'">
      <h1 class="logo">
        <Img src="/logo1@2x.png" @click.native="$router.push({ name: 'home' })" alt="" />
        <!-- <span @click="$router.push({ name: 'home' })">CTIS竞赛平台</span> -->
      </h1>
      <nav>
        <ul>
          <li
            :class="{ active: $route.meta.belong === item.routerName }"
            v-for="(item, index) in menuList"
            :key="index"
            @click="$router.push({ name: item.routerName })"
          >
            <Img :src="item.icon" alt="" />
            <span>{{ item.title }}</span>
          </li>
        </ul>
      </nav>
      <div class="ownaction" v-if="!isExamView">
        <Img src="/avatar.png" class="avatar" alt="" v-if="originCtis && XToken" />
        <Poptip placement="bottom-end" width="200" v-else-if="XToken">
          <Img src="/avatar.png" class="avatar" alt="" />
          <div class="user-content" slot="content">
            <div class="user-content-phone">
              {{ name }}
            </div>
            <!-- <p class="edit-pwd" @click="editPwdVisible = true">修改密码</p> -->
            <p class="logout" @click="$router.push({ name: 'my_competition' })">我的比赛</p>
            <p class="logout" @click="handleLogout">退出</p>
          </div>
        </Poptip>
        <router-link :to="{ name: 'login' }" class="login-btn" v-else>请登录</router-link>
      </div>
    </div>
    <Modal_ :visible.sync="editPwdVisible" title="修改密码" :width="500" @Ok="handleUpdatePwd('formPwd')">
      <Form ref="formPwd" :model="formPwd" :rules="rules" :label-width="100">
        <FormItem prop="pwd" label="旧密码">
          <Input type="password" v-model="formPwd.pwd" placeholder="请输入旧密码" />
        </FormItem>
        <FormItem prop="password" label="新密码">
          <Input type="password" v-model="formPwd.password" placeholder="请输入新密码" />
        </FormItem>
        <FormItem prop="checkPassword" label="确认密码">
          <Input type="password" v-model="formPwd.checkPassword" placeholder="请再次输入新密码" />
        </FormItem>
      </Form>
      <p class="note" style="color: red; font-size: 12px; padding-left: 100px">
        提醒：请记住修改后的密码
      </p>
      <br />
    </Modal_>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { Modal, Poptip, Form, FormItem, Input, Message } from 'view-design'
import { mapState } from 'vuex'
import Modal_ from '@/components/Modal'
import { PUValid } from '@/utils/check'
import sha256 from 'js-sha256'

export default {
  components: {
    Poptip,
    Modal_,
    Form,
    FormItem,
    Input
  },
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value !== this.formPwd.password) {
        callback(new Error('两次密码输入不一致！'))
      } else {
        callback()
      }
    }
    return {
      editPwdVisible: false, // 修改密码的弹窗
      name: '',
      menuList: [
        // {
        //   icon: '/nav-icon1.png',
        //   title: '首页',
        //   routerName: 'home'
        // }
      ],
      formPwd: {
        // 修改密码
        pwd: '',
        password: '',
        checkPassword: ''
      },
      rules: {
        pwd: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: PUValid, message: '密码格式错误', trigger: 'blur' }
        ],
        checkPassword: [
          { required: true, message: '请再次确认密码', trigger: 'blur' },
          { validator: PUValid, message: '密码格式错误', trigger: 'blur' },
          { validator: validatePassCheck, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState(['userinfo', 'breadList', 'userLimits']),
    // token
    XToken() {
      return localStorage.getItem('X-Token')
    },
    // 来源是否是ctis
    originCtis() {
      return localStorage.getItem('origin') === 'ctis'
    },
    // 是否是真实竞赛（默认模拟）
    realExam() {
      return localStorage.getItem('realExam') == '1'
    },
    // 是否是直接查看回顾试题
    isExamView() {
      return this.$route.name === 'exam-view'
    }
  },
  created() {
    this.$store.dispatch('getUserinfo')
    const user = localStorage.getItem('userInfo')
    this.name = localStorage.getItem('userName')
    if(user) {
      this.$store.dispatch('getUserAuthInfo')
    }
  },
  methods: {
    // 登出确认框
    handleLogout() {
      Modal.confirm({
        title: '提示',
        content: '确定退出当前系统？',
        loading: true,
        onOk: () => {
          Modal.remove()
          localStorage.clear()
          this.$router.push({ name: 'home' })
          this.$store.dispatch('resetState')
          location.reload()
        }
      })
    },
    handleUpdatePwd(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.updatePwd()
        }
      })
    },
    // 修改密码
    async updatePwd() {
      const params = {
        uriCode: 'API014',
        pwd: sha256(this.formPwd.pwd),
        password: sha256(this.formPwd.password)
      }
      await this.$fetch(params)
      this.editPwdVisible = false
      this.logout()
      Message.success('修改密码成功！，请重新登录')
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  height: 100vh;
}
.header {
  width: 100%;
  height: 50px;
  background: #484848;
  color: #fff;
  display: flex;
  position: relative;
  &.home-header {
    background-color: #484848;
  }
  h1 {
    width: 500px;
    height: 100%;
    padding-left: 36px;
    display: flex;
    align-items: center;
    img {
      height: 22px;
    }
    span {
      cursor: pointer;
      font-size: 23px;
    }
  }
}
nav {
  ul {
    display: flex;
    height: 100%;
    li {
      display: flex;
      align-items: center;
      height: 100%;
      margin-right: 100px;
      font-size: 16px;
      cursor: pointer;
      img {
        margin-right: 10px;
      }
      span {
        display: block;
        height: 100%;
        line-height: 60px;
        font-size: 16px;
      }
      &.active span {
        border-bottom: 6px solid #fff;
      }
    }
  }
}
.content {
  width: 100%;
  height: calc(100vh - 50px);
  overflow: auto;
}
.ownaction {
  display: flex;
  align-items: center;
  position: absolute;
  justify-content: flex-end;
  top: 50%;
  transform: translateY(-50%);
  right: 18px;
  width: 90px;
  height: 40px;
  z-index: 9;
  // a {
  //   color: #fff;
  //   margin-right: 10px;
  //   display: block;
  //   width: 110px;
  //   text-align: right;
  // }
  .user-content {
    color: #414e5e;
    padding: 0px 5px 0;
    box-sizing: border-box;
    &-phone {
      display: flex;
      line-height: 40px;
      a {
        margin-left: 20px;
        color: #015fff;
      }
    }

    .logout {
      height: 40px;
      line-height: 40px;
      border-top: 1px solid #eeeff0;
      cursor: pointer;
      &:hover {
        color: #0055ff;
      }
    }
    .edit-pwd {
      line-height: 35px;
      cursor: pointer;
      &:hover {
        color: #0055ff;
      }
    }
  }
  // cursor: pointer;
}

.login-btn {
  display: block;
  width: 90px;
  height: 32px;
  background: linear-gradient(225deg, #92d5c9 0%, #59ab99 100%);
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
}
</style>
